import { BaseDto } from './base.dto';
import { EntityTypeFieldDto } from './entityTypeField.dto';

export class EntityTypeDto extends BaseDto {
  name: string;
  fields?: EntityTypeFieldDto[];
}
  